import React from "react";

function Promise() {
    return (
        < section className="py-16 px-4 sm:px-6 lg:px-8 bg-gray-50" >
            <div className="max-w-4xl mx-auto text-center">
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                    Our Promise:
                </h2>
                <p className="text-lg text-gray-700">
                    <span role="img" aria-label="globe">🌍</span> We are an equal opportunity employer. We welcome candidates of
                    all backgrounds who are passionate about real estate and success.
                </p>
                <p className="mt-8 text-sm text-gray-500">
                    Careers in Dubai Real Estate | Join UCS Prime | Property
                    Consultant Jobs UAE
                </p>
            </div>
        </section >
    )
}

export default Promise;